import SectionHead from "./SectionHead";
import { spotlight, spotlightMini } from "@/mocks/cgua";

export default function Spotlight() {
  return (
    <section id="jingxuan" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          no="02"
          eyebrow="17吃瓜精选"
          title="精选聚焦 · 本周一条主线"
          desc="把一整周反复横跳的瓜，收成一段好读、可保存的主线。"
          linkLabel="更多精选"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* 主卡 大卡 */}
          <article className="lg:col-span-8 group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-colors">
            <div className="relative w-full h-[260px] md:h-[340px] overflow-hidden">
              <img
                src={spotlight.cover}
                alt="17吃瓜精选 深度主线图"
                title="17吃瓜精选 深度专栏"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
              />
              <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-foreground-950/80 text-background-50 text-xs font-bold px-3 py-1.5">
                <i className="ri-vip-diamond-line text-[13px]" />
                {spotlight.badge}
              </span>
            </div>
            <div className="p-5 md:p-6">
              <h3 className="text-lg md:text-2xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                {spotlight.title}
              </h3>
              <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">
                {spotlight.lead}
              </p>
              <ul className="mt-4 space-y-2">
                {spotlight.bullets.map((b, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-foreground-800">
                    <span className="mt-1 flex items-center justify-center w-4 h-4 shrink-0 rounded-full bg-accent-500 text-foreground-950">
                      <i className="ri-check-line text-[10px] font-bold" />
                    </span>
                    {b}
                  </li>
                ))}
              </ul>
              <a
                href="#"
                className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold px-5 py-2.5 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                读完整条主线
                <i className="ri-arrow-right-line text-[15px]" />
              </a>
            </div>
          </article>

          {/* 右侧 小卡列 */}
          <aside className="lg:col-span-4 flex flex-col gap-4">
            {spotlightMini.map((m, i) => (
              <article
                key={i}
                className="group rounded-xl bg-background-50 border border-background-200 p-4 md:p-5 flex flex-col hover:border-primary-200 transition-colors"
              >
                <div className="flex items-center gap-2 text-xs">
                  <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 text-secondary-900 px-2.5 py-1 font-semibold">
                    <i className="ri-price-tag-3-line text-[12px]" />
                    {m.tag}
                  </span>
                  <span className="text-foreground-400 flex items-center gap-1">
                    <i className="ri-fire-line text-[12px]" />
                    {m.heat}
                  </span>
                </div>
                <h4 className="mt-2.5 text-[15px] font-semibold text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors">
                  {m.title}
                </h4>
                <a
                  href="#"
                  className="mt-auto pt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 whitespace-nowrap cursor-pointer"
                >
                  进入详情
                  <i className="ri-arrow-right-s-line text-[14px]" />
                </a>
              </article>
            ))}
          </aside>
        </div>
      </div>
    </section>
  );
}